import {Observacion} from "./Observacion";
import {Details} from "./Details";

export class ReportRemito {
  origen: string;
  nroRemito: number;
  codDealer: string;
  nroShipper: number;
  clase: string;
  fecGen: Date | null = new Date();
  shipTo: string;
  shipFrom: string;
  codTransp: string;
  patenteTransp: string;
  estadoRemito: string;
  totCont: number;
  pesoNeto: string;
  pesoBruto: string;
  ptoEmision: string;
  observacions: Observacion;
  details: Details;
  nombreDealer: string;
  descAlmacen: string;
  nombreTransp: string;





  /**
   * This maps the data obj received from http client, which
   * contains fecProceso as a date, to a MgoErrorProcessing.ts obj with fecProceso
   * as a date for compatibility with our column filters.
   * @param data The data received from HttpClient.
   */
  static transformData(data: any): ReportRemito {
    let reportRemito = new ReportRemito();
    reportRemito.origen = data.origen;
    reportRemito.nroRemito = data.nroRemito.toString();
    reportRemito.nombreDealer = data.nombreDealer;
    reportRemito.descAlmacen = data.descAlmacen;

    if(data.nroShipper != null){
      reportRemito.nroShipper = data.nroShipper.toString();
    }else{
      reportRemito.nroShipper = data.nroShipper;
    }

    reportRemito.clase = data.clase;
    reportRemito.fecGen = data.fecGen != null ? new Date(data.fecGen) : null;
    reportRemito.shipTo = data.shipTo;
    reportRemito.shipFrom = data.shipFrom;
    reportRemito.nombreTransp = data.nombreTransp;
    reportRemito.patenteTransp = data.patenteTransp;
    reportRemito.estadoRemito = data.estadoRemito;
    reportRemito.totCont = data.totCont;
    reportRemito.pesoNeto = data.pesoNeto;
    reportRemito.pesoBruto = data.pesoBruto;
    reportRemito.ptoEmision = data.ptoEmision;
    reportRemito.observacions = data.observacions;
    reportRemito.details = data.details;

    return reportRemito;
  }
}


